import { colors, strings } from "asset/constant";
import { Text, Timer } from "component";
import React from "react";
import { TouchableOpacity, View } from "react-native";

import { css } from "style";
import { mq } from "utils";

interface TimerSectionT {
  getCodeAgain: () => void;
}

export default function TimerSection(props: TimerSectionT) {
  const isCurrent = React.useRef(true);
  const [showTimer, setShowTimer] = React.useState(true);

  const finishTimer = () => isCurrent && setShowTimer(false);

  React.useEffect(() => {
    return () => {
      isCurrent.current = false;
    };
  }, []);
  return (
    <View style={[css.height(25), css.margins(30), css.selfCenter]}>
      {showTimer ? (
        <View style={css.rowCenterAlign}>
          <Text>{strings.until_code_resent("")} </Text>

          <View style={{ borderRadius: 5, marginHorizontal: 4 }}>
            <Timer hideHour onFinish={finishTimer} duration={180} />
          </View>
        </View>
      ) : (
        <TouchableOpacity
          style={[css.width(mq(250))]}
          onPress={() => {
            props.getCodeAgain();
            setShowTimer(true);
          }}
        >
          <View style={[css.rowCenterAlign, css.selfCenter]}>
            <Text style={css.textUnderline} color={colors.info}>
              {" "}
              {strings.send_code_again}{" "}
            </Text>
            <Text>{strings.did_not_receive_code}</Text>
          </View>
        </TouchableOpacity>
      )}
    </View>
  );
}
